<ng-container
  *ngIf="selectedApp && (selectedApp.title == 'STARS Keyboard' || selectedApp.name == 'STARS Keyboard'); else otherApp">
  <app-members-tab-stars-lessons-analtics [userName]="userData.userName" [dateData$]="api.dateRange$"
    [selectedApp]="selectedApp"></app-members-tab-stars-lessons-analtics>
</ng-container>
<ng-template #otherApp>
  <div class="px-rlt">
    <div fxLayout="column" fxFlex="100%" fxLayoutGap="10px" style="padding: 0px !important">
      <div fxLayout="row" fxFlex="100%" fxLayoutGap="10px" class="user-details-nav-row">
        <mat-card fxLayout="row" fxLayoutAlign="start center" *ngIf="name" fxFlex="80%">
          <span pointer (click)="api.backRoutes()" *ngIf="!name && api.previousRoute[api.previousRoute.length - 2]">{{
            api.previousRoute[api.previousRoute.length - 2].data.name }}</span>
          <span pointer (click)="exit.emit({ exit: true })"><em class="fa fa-sticky-note route-icon"></em>{{ pSetName ?
            pSetName : "Practice Set Analytics" }}</span>
          <mat-icon>keyboard_arrow_right</mat-icon>
          <span><em class="fa fa-user route-icon"></em>{{ name ? name : "User Details" }}</span>
        </mat-card>

        <mat-card fxLayout="row" fxLayoutAlign="center center" *ngIf="name" fxFlex="20%">
          <app-date-selector [selectedDateRange]="dateRangeType" (changeDate)="getDate($event)"></app-date-selector>
        </mat-card>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between stretch" class="row-equal-height"
        *ngIf="userData.userDetails && (selectedApp && (selectedApp.title == 'ATC Phraseology' || selectedApp.name == 'ATC Phraseology'))">
        <!-- <mat-card fxLayout="row" fxLayoutAlign="start center" fxFlex="30%" class="card-height-30">-->
        <mat-card class="card-height-30 row-equal-height mr-5" fxLayout="row" fxLayoutAlign="space-between center"
          fxFlex="30%">
          <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%">
            <!-- Avatar -->
            <div class="avatar">
              {{ userData.userDetails.nameIcon | uppercase }}
            </div>

            <!-- User info -->
            <div fxLayout="column" class="user-info">
              <div fxLayout="row" fxLayoutAlign="start center" class="user-name-row">
                <span class="username">
                  {{ userData.userDetails.usernameDec }}
                </span>

                <span class="role-pill" [ngClass]="(userData.userDetails.userRole === 'Member' || userData.userDetails.userRole === 'Guest')
    ? 'member-pill'
    : 'organizer-pill'">
                  {{ userData.userDetails.userRole | titlecase }}
                </span>
              </div>
              <span class="last-active" *ngIf="userData.userDetails.usernameDec != userData.userDetails.emailDec">
                {{ userData.userDetails.emailDec }}
              </span>
              <span class="last-active">
                Last Active<br />
                {{ userData.userDetails.active | date: 'MMM d, yyyy h:mm a' }}
              </span>
              <span class="last-active" *ngIf="userData.userDetails.usernameDec == userData.userDetails.emailDec">
                &nbsp;&nbsp;
              </span>
            </div>
          </mat-card-content>
        </mat-card>
        <app-atc-practice-set-consolidated-count-tab-analtics fxFlex="70%" [userName]="userData.userName"
          [dateData$]="api.dateRange$"
          [selectedApp]="selectedApp"></app-atc-practice-set-consolidated-count-tab-analtics>

      </div>
      <!-- Command Category (consolidated ratio) hidden per request
    <div fxLayout="row" fxLayoutAlign="space-between stretch"
      *ngIf="userData.userDetails && (selectedApp && (selectedApp.title == 'ATC Phraseology' || selectedApp.name == 'ATC Phraseology'))">
      <app-atc-practice-set-consolidated-ratio-tab-analtics [userName]="userData.userName"
        [dateData$]="api.dateRange$" [selectedApp]="selectedApp"
        fxFlex="100%"></app-atc-practice-set-consolidated-ratio-tab-analtics>
    </div>
    -->
      <div fxLayout="row" fxLayoutAlign="space-between stretch" fxFlex="420px" fxLayoutGap="10px">
        <mat-card *ngIf="selectedApp && selectedApp?.title != 'ATC Phraseology'" fxLayout="column" fxFlex="25%"
          fxLayoutAlign="space-between center" fxLayoutGap="22px" style="word-break: break-all; text-align: center">
          <ng-container *ngIf="userData.userDetails">
            <div fxLayout="row" fxFlex>
              <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" fxLayoutGap="12px">
                <div ngClass="circle" fxLayout="row" fxLayoutAlign="center center">
                  {{ userData.userDetails.nameIcon }}
                </div>
                <mat-card-title>{{ userData.userDetails.usernameDec }}</mat-card-title>
                <mat-card-subtitle>{{ userData.userDetails.emailDec }}</mat-card-subtitle>
                <span [ngClass]="[userData.userDetails.userRole]"
                  style="font-family: 'Montserrat', sans-serif !important; color: rgba(0, 0, 0, 0.87) !important; font-size: 14px">{{
                  userData.userDetails.userRole
                  }}</span>
              </div>
            </div>
            <div fxLayout="column" fxFlex="100%" fxLayoutAlign="center center" fxLayoutGap="12px">
              <span
                style="font-family: 'Montserrat', sans-serif !important; color: rgba(0, 0, 0, 0.87) !important; font-size: 14px">Last
                Active</span>
              <mat-divider></mat-divider>
              <mat-card-subtitle fontWeight="700" fxLayoutAlign="center center">{{ userData.userDetails.active | date :
                "longDate" }}</mat-card-subtitle>
              <mat-card-subtitle fontWeight="700" fxLayoutAlign="center center">{{ userData.userDetails.active | date :
                "shortTime" }}</mat-card-subtitle>
            </div>
          </ng-container>
          <ng-container *ngIf="userData.userDetailsMessage">
            <mat-card-subtitle>&nbsp;</mat-card-subtitle>
            <div fxLayout="row" fxLayoutAlign="center center" fxFlex>
              {{ userData.userDetailsMessage }}
            </div>
          </ng-container>
        </mat-card>

        <ng-container *ngIf="userData.userDetails && (userData?.userDetails?.userRole != 'Guest'
       || (selectedApp && selectedApp.title == 'ATC Phraseology')); else bigCard">
          <!-- TEAMS START -->
          <!-- Hide TEAMS for nickname/Guest users on ATC Phraseology (keep for normal users) -->
          <mat-card fxLayout="column" fxFlex="35%" style="padding: 10px 10px 10px 0px !important"
            *ngIf="!(userData?.userDetails?.userRole == 'Guest' && selectedApp && selectedApp.title == 'ATC Phraseology')">
            <mat-card-subtitle cardHeader>TEAMS</mat-card-subtitle>
            <app-table fxLayout="row" fxFlex [data]="userData.teams" *ngIf="userData.teams"
              (teamsList)="openTeamsDialog($event)"></app-table>
            <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!userData.teams">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          </mat-card>
          <!-- TEAMS END   -->

          <ng-container
            *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'ERAM Keyboard'; else otherApp1">
            <mat-card fxLayout="column" fxFlex="40%">
              <mat-card-subtitle cardHeader>Completed Lesson</mat-card-subtitle>
              <app-table fxLayout="row" fxFlex [data]="completedLessons" (teamsList)="openPSetAnalytics($event)"
                *ngIf="!isload"></app-table>
              <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="isLessonload">
                <mat-spinner diameter="20"></mat-spinner>
              </div>
            </mat-card>
          </ng-container>
          <!-- ***************SG-4637 start  ******************* -->

          <ng-template #otherApp1>
            <ng-container
              *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'Advanced Vectoring'; else otherApp2">
              <mat-card fxLayout="column" fxFlex="40%" style="padding: 4px">
                <app-adavance-vectoring-users [dateData$]="api.dateRange$"
                  [selectedApp]="selectedApp"></app-adavance-vectoring-users>
              </mat-card>
            </ng-container>
          </ng-template>

          <ng-template #otherApp2>
            <ng-container
              *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'Basic Vectoring'; else otherApp">
              <mat-card fxLayout="column" fxFlex="40%" style="padding: 4px">
                <app-basic-vectoring-users [dateData$]="api.dateRange$"
                  [selectedApp]="selectedApp"></app-basic-vectoring-users>
              </mat-card>
            </ng-container>
          </ng-template>
          <!-- ***************SG-4637 end  ******************* -->

          <ng-template #otherApp>
            <mat-card fxLayout="column"
              [fxFlex]="selectedApp?.title === 'ATC Phraseology' ? (userData?.userDetails?.userRole == 'Guest' ? '100%' : '65%') : '40%'">
              <ng-container *ngIf="userData.userDetails">
                <mat-card-subtitle cardHeader *ngIf="selectedApp && selectedApp?.title != 'ATC Phraseology'">COMPLETED
                  PRACTICE SET</mat-card-subtitle>
                <mat-card-subtitle cardHeader *ngIf="selectedApp && selectedApp?.title == 'ATC Phraseology'">PRACTICE
                  SETS</mat-card-subtitle>
                <app-table fxLayout="row" fxFlex [data]="completedPracticeSets" (teamsList)="openPSetAnalytics($event)"
                  *ngIf="!isload"></app-table>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="isload">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
              </ng-container>
            </mat-card>
          </ng-template>
        </ng-container>

        <ng-template #bigCard>
          <ng-container
            *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'ERAM Keyboard'; else otherApp1">
            <mat-card fxLayout="column" [fxFlex]="'75%'">
              <mat-card-subtitle cardHeader>Completed Lesson</mat-card-subtitle>
              <app-table fxLayout="row" fxFlex [data]="completedLessons" (teamsList)="openPSetAnalytics($event)"
                *ngIf="!isload"></app-table>
              <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="isLessonload">
                <mat-spinner diameter="20"></mat-spinner>
              </div>
            </mat-card>
          </ng-container>
          <!-- *************** SG-4637 start****************** -->

          <ng-template #otherApp1>
            <ng-container
              *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'Advanced Vectoring'; else otherApp2">
              <mat-card fxLayout="column" fxFlex="75%" style="padding: 4px">
                <app-adavance-vectoring-users [dateData$]="api.dateRange$"
                  [selectedApp]="selectedApp"></app-adavance-vectoring-users>
              </mat-card>
            </ng-container>
          </ng-template>

          <ng-template #otherApp2>
            <ng-container
              *ngIf="userData.userDetails && selectedApp && selectedApp.title == 'Basic Vectoring'; else otherApp">
              <mat-card fxLayout="column" fxFlex="75%" style="padding: 4px">
                <app-basic-vectoring-users [dateData$]="api.dateRange$"
                  [selectedApp]="selectedApp"></app-basic-vectoring-users>
              </mat-card>
            </ng-container>
          </ng-template>
          <!-- *************** SG-4637 end******************
 -->
          <ng-template #otherApp>
            <mat-card fxLayout="column" *ngIf="showTeamTab" [fxFlex]="'35%'">
              <mat-card-subtitle cardHeader>TEAMS</mat-card-subtitle>
              <app-table fxLayout="row" fxFlex [data]="userData.teams" *ngIf="userData.teams"
                (teamsList)="openTeamsDialog($event)"></app-table>
              <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!userData.teams">
                <mat-spinner diameter="20"></mat-spinner>
              </div>
            </mat-card>
            <mat-card fxLayout="column" [fxFlex]="showTeamTab ? '35%' : '75%'">
              <ng-container *ngIf="userData.userDetails">
                <mat-card-subtitle cardHeader>COMPLETED PRACTICE SET</mat-card-subtitle>
                <app-table class="completed-records" fxFlex fxLayout="row" [data]="completedPracticeSets"
                  (teamsList)="openPSetAnalytics($event)" *ngIf="!isload"></app-table>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="isload">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
              </ng-container>
            </mat-card>
          </ng-template>
        </ng-template>
      </div>
      <!-- ***************SG-4637 start  ******************* -->

      <app-basic-vectoring-users-graph *ngIf="selectedApp && selectedApp.title == 'Basic Vectoring'"
        [dateData$]="api.dateRange$" fxLayout="column" fxFlex="100%"
        fxLayoutGap="5px"></app-basic-vectoring-users-graph>
      <app-advance-vectoring-users-graph *ngIf="selectedApp && selectedApp.title == 'Advanced Vectoring'"
        [dateData$]="api.dateRange$" fxLayout="column" fxFlex="100%"
        fxLayoutGap="5px"></app-advance-vectoring-users-graph>
      <app-atc-practice-set-analytics *ngIf="selectedApp && selectedApp.title == 'ATC Phraseology'"
        [dateData$]="api.dateRange$" fxFlex="85%" fxLayoutGap="5px" [isGraphOnly]="true"
        [selectedApp]="selectedApp"></app-atc-practice-set-analytics>
      <ng-container *ngIf="selectedApp as app">
        <ng-container *ngFor="let item of [app]; trackBy: trackByApp">
          <app-eram-lesson-analytics *ngIf="app.title !== 'Basic Vectoring' && app.title !== 'Advanced Vectoring'
         && app.title !== 'ATC Phraseology'" [dateData$]="api.dateRange$" fxFlex="85%" fxLayoutGap="5px"
            [isGraphOnly]="true" [selectedApp]="app"></app-eram-lesson-analytics>
        </ng-container>
      </ng-container>

      <!-- ***************SG-4637 end  ******************* -->
    </div>
  </div>
</ng-template>